import { createSlice } from '@reduxjs/toolkit';
import { Category } from '../types/category';
import type { PayloadAction } from '@reduxjs/toolkit';
import {
  getCategoriesApi,
  createParentCategoryApi,
  createChildCategoryApi,
  updateCategoryApi,
} from '../services/category/category';
import { setAlert } from './commonSlice';
import { createQuery } from '../utils/constants';

interface InitialState {
  categories: Category[];
  filter: Filter;
  loader: boolean;
  saveLoader: boolean;
  selectedCategory: Category | null;
}

interface Filter {
  isParent: boolean | null;
  id: number | null;
}

const initialState: InitialState = {
  categories: [],
  filter: {
    isParent: false,
    id: null,
  },
  loader: false,
  saveLoader: false,
  selectedCategory: null,
};

export const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    getAll: (state, action: PayloadAction<any>) => {
      state.categories = action.payload.manufacturers;
    },
    setAll: (state, action: PayloadAction<any>) => {
      state.categories = action.payload;
    },
    setFilter: (state, action: PayloadAction<any>) => {
      state.filter = action.payload;
    },
    setLoader: (state, action: PayloadAction<any>) => {
      state.loader = action.payload;
    },
    setSaveLoader: (state, action: PayloadAction<any>) => {
      state.saveLoader = action.payload;
    },
    set: (state, action: PayloadAction<any>) => {
      state.selectedCategory = action.payload;
    },
  },
});

export const { getAll, setAll, setFilter, setLoader, setSaveLoader, set } = categorySlice.actions;
export default categorySlice.reducer;

export const getCategories = (payload: any) => async (dispatch: any, getState: any) => {
  try {
    dispatch(setLoader(true));
    const { filter } = getState().category;
    const queryParams = { ...filter, ...payload };
    const query = '?' + createQuery({ filter: queryParams });

    const response = await getCategoriesApi(query);
    if (response.kind === 'ok') {
      const { data: list } = response.data;

      dispatch(setAll(list));
    }
  } catch (error) {
  } finally {
    dispatch(setLoader(false));
  }
};

export const getCategory = (id: number) => async (dispatch: any, getState: any) => {
  if (id) {
    try {
      const query = `?id=${id}`;

      const response = await getCategoriesApi(query);
      if (response.kind === 'ok') {
        const { data: list } = response.data;

        if (list.length) {
          dispatch(set(list[0]));
        }
      }
    } catch (error) {
    } finally {
      dispatch(setLoader(false));
    }
  } else {
    dispatch(set(null));
  }
};

export const createParentCategory = (payload: any, cb?: any) => async (dispatch: any) => {
  try {
    dispatch(setSaveLoader(true));
    const result = await createParentCategoryApi(payload);
    if (result?.kind === 'ok') {
      dispatch(setAlert('Category has been created successfully', 'success'));
      cb?.(result?.data?.data, true);
    } else {
      /*Toast.show({
        type: 'error',
        text1: 'Failed',
        text2: 'Failed to create address',
      });*/
    }
  } catch (err) {
  } finally {
    dispatch(setSaveLoader(false));
  }
};

export const createChildCategory = (parentId: number, payload: any, cb?: any) => async (dispatch: any) => {
  try {
    dispatch(setSaveLoader(true));
    const result = await createChildCategoryApi(parentId, payload);
    if (result?.kind === 'ok') {
      dispatch(setAlert('Sub Category has been created successfully', 'success'));
      cb?.(null, true);
    } else {
      /*Toast.show({
        type: 'error',
        text1: 'Failed',
        text2: 'Failed to create address',
      });*/
    }
  } catch (err) {
  } finally {
    dispatch(setSaveLoader(false));
  }
};

export const updateCategory = (id: any, payload: any, cb?: any) => async (dispatch: any) => {
  try {
    dispatch(setSaveLoader(true));
    const result = await updateCategoryApi(id, payload);
    if (result?.kind === 'ok') {
      dispatch(setAlert('Category has been updated successfully', 'success'));
      cb?.(null, true);
    } else {
      /*Toast.show({
        type: 'error',
        text1: 'Failed',
        text2: 'Failed to create address',
      });*/
    }
  } catch (err) {
  } finally {
    dispatch(setSaveLoader(false));
  }
};

export const applyFilter = (payload: any) => async (dispatch: any, getState: any) => {
  return dispatch(setFilter(payload));
};
